export enum AccountMemberActionsEnum {
  Suspend = 'suspend',
  RoleA = 'roleA',
  RoleD = 'roleD',
  RoleV = 'roleV',
  Delete = 'delete',
}
